import React from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
import { SquircleView } from 'react-native-figma-squircle';
import useColors from 'hooks/useColors';
const Badge = ({ style, children, ...props }) => {
    const colors = useColors();
    return (<SquircleView style={[styles.container, style]} squircleParams={{
            cornerSmoothing: 1,
            cornerRadius: rem(8),
            fillColor: colors.background.contrast,
        }} {...props}>
      <Text Text-14 White>
        {children}
      </Text>
    </SquircleView>);
};
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: rem(12),
        paddingVertical: rem(6),
        justifyContent: 'center',
    },
});
export default Badge;
